import { ITheme } from "./Theme";
import { types } from "./Theme.actions";

export interface IThemeStateProps {
  theme: ITheme;
}

const defaultState: IThemeStateProps = {
  theme: {}
};

export const theme = (state = defaultState, action) => {
  switch (action.type) {
    case types.RESET_THEME:
      return {
        ...state,
        theme: null
      };
    case types.SET_THEME:
      return {
        ...state,
        theme: action.value
      };
    default:
      return state;
  }
};
